import React from 'react'

export default () => (
  <svg
    version="1.1"
    viewBox="0 0 4 9"
    height="10px"
    width="10px"
  >
    <path d="M3.06521739,8.07391304 C3.06521739,8.48478261 2.74565217,8.80434783 2.33478261,8.80434783 L1.66521739,8.80434783 C1.25434783,8.80434783 0.934782609,8.48478261 0.934782609,8.07391304 L0.934782609,4.05652174 C0.934782609,3.64565217 1.25434783,3.32608696 1.66521739,3.32608696 L2.33478261,3.32608696 C2.74565217,3.32608696 3.06521739,3.64565217 3.06521739,4.05652174 L3.06521739,8.07391304 Z" />
    <path d="M3.06521739,1.83478261 C3.06521739,2.24565217 2.74565217,2.56521739 2.33478261,2.56521739 L1.66521739,2.56521739 C1.25434783,2.56521739 0.934782609,2.24565217 0.934782609,1.83478261 L0.934782609,1.16521739 C0.934782609,0.754347826 1.25434783,0.434782609 1.66521739,0.434782609 L2.33478261,0.434782609 C2.74565217,0.434782609 3.06521739,0.754347826 3.06521739,1.16521739 L3.06521739,1.83478261 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/modules/icons/infoIcon.jsx